import { request } from '@umijs/max';

// 查询banner list信息
export async function getBannerListService(params: any) {
  return request(`/bcare/banner/list`, {
    params,
  });
}

// 广告位配置
export async function maintenanceService(data: any) {
  return request('/bcare/banner/maintenance', {
    method: 'POST',
    data,
  });
}

// banner操作
export async function bannerOperationService(params: any, data: any) {
  return request(`/bcare/banner/maintenance`, {
    method: 'POST',
    params,
    data,
  });
}
